import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useRouteLoaderData } from '@remix-run/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import Signup from '~/components/Signup';

interface EmailCaptureModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  premiumOfferId: string;
}

const EmailCaptureModal = ({ isOpen, onClose, onConfirm, premiumOfferId }: EmailCaptureModalProps) => {
  const { signupWidgetConfigs } = useRouteLoaderData<any>('root');
  const { t } = useTranslation();

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="z-80 relative" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-50"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-50"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="z-100 fixed inset-0 bg-black bg-opacity-80" />
        </Transition.Child>

        <div className="fixed inset-0 z-20 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-50"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-50"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative -mt-32 w-full max-w-md transform overflow-auto rounded-md bg-white p-6 text-left align-middle shadow-xl transition-all">
                <button aria-label="Close" className="absolute right-4 top-4" onClick={onClose}>
                  <XMarkIcon className="h-6 w-6 stroke-1 text-gray-400 transition-all hover:text-gray-700" />
                </button>
                <Dialog.Title as="h3" className="tracking-medium pb-1 text-xl font-bold leading-tight text-gray-900">
                  {t('shared.cta.get_access')}
                </Dialog.Title>
                <Dialog.Description
                  as="h5"
                  className="mb-4 pb-1 text-sm font-light leading-tight tracking-wider text-gray-500"
                >
                  {t('subscribe.free_trial')}
                </Dialog.Description>
                <Signup signupStyles={signupWidgetConfigs} onSuccess={onConfirm} premiumOfferId={premiumOfferId} />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default EmailCaptureModal;
